/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientProcedureOrder from './patient-procedure-order';
import PatientProcedureOrderDetail from './patient-procedure-order-detail';
import PatientProcedureOrderUpdate from './patient-procedure-order-update';
import PatientProcedureOrderDeleteDialog from './patient-procedure-order-delete-dialog';

const PatientProcedureOrderRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientProcedureOrder />} />
    <Route path="new" element={<PatientProcedureOrderUpdate />} />
    <Route path=":id">
      <Route index element={<PatientProcedureOrderDetail />} />
      <Route path="edit" element={<PatientProcedureOrderUpdate />} />
      <Route path="delete" element={<PatientProcedureOrderDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientProcedureOrderRoutes;
